/* DV-AI-ROOM-ANALYZER-V5.4 */
(function (root, factory) {
  'use strict';

  var api = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
    return;
  }

  root.DolceAiRoomAnalyzerV5 = api;
  api.boot();
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  var VERSION = 'DV-AI-ROOM-ANALYZER-V5.4';
  var CATALOG_VERSION = 'DV-AI-STOCK-CATALOG-V2';
  var STOCK_RULE = "variant.inventory_management == 'shopify' && variant.available == true && variant.inventory_quantity > 0";
  var DEFAULT_CATALOG_URL = '/collections/all?view=ai-room-products';
  var DEFAULT_VISION_URL = 'https://dolce-openai-proxy.vercel.app/api/openai-vision';
  var MAX_CATALOG_PAGES = 20;
  var MAX_RECOMMENDATIONS = 6;
  var VERIFY_POOL_SIZE = 18;
  var VISUAL_POOL_SIZE = 9;
  var MIN_VISUAL_MATCH_SCORE = 70;
  var stateByScope = typeof WeakMap === 'function' ? new WeakMap() : null;

  var COLOR_DEFINITIONS = [
    { name: 'bej', terms: ['bej', 'beige'] },
    { name: 'krem', terms: ['krem', 'cream', 'ekru', 'fildisi'] },
    { name: 'vizon', terms: ['vizon', 'mink'] },
    { name: 'gri', terms: ['gri', 'grey', 'gray', 'gumus'] },
    { name: 'antrasit', terms: ['antrasit', 'anthracite', 'fume'] },
    { name: 'beyaz', terms: ['beyaz', 'white'] },
    { name: 'siyah', terms: ['siyah', 'black'] },
    { name: 'kahverengi', terms: ['kahverengi', 'brown', 'taba', 'toprak'] },
    { name: 'mavi', terms: ['mavi', 'blue'] },
    { name: 'lacivert', terms: ['lacivert', 'navy'] },
    { name: 'turkuaz', terms: ['turkuaz', 'turquoise'] },
    { name: 'yeşil', terms: ['yesil', 'green', 'mint', 'haki', 'zeytin'] },
    { name: 'pembe', terms: ['pembe', 'pink', 'pudra'] },
    { name: 'mor', terms: ['mor', 'purple', 'lila', 'eflatun'] },
    { name: 'bordo', terms: ['bordo', 'burgundy'] },
    { name: 'kırmızı', terms: ['kirmizi', 'red'] },
    { name: 'turuncu', terms: ['turuncu', 'orange'] },
    { name: 'sarı', terms: ['sari', 'yellow', 'hardal'] },
    { name: 'altın', terms: ['altin', 'gold'] }
  ];

  var COLOR_NEIGHBOURS = {
    bej: ['krem', 'vizon', 'kahverengi', 'beyaz'],
    krem: ['bej', 'beyaz', 'vizon'],
    vizon: ['bej', 'krem', 'kahverengi'],
    gri: ['antrasit', 'beyaz', 'siyah'],
    antrasit: ['gri', 'siyah'],
    beyaz: ['krem', 'bej', 'gri'],
    mavi: ['lacivert', 'turkuaz'],
    lacivert: ['mavi', 'gri'],
    yeşil: ['bej', 'krem', 'kahverengi'],
    pembe: ['mor', 'krem', 'bej'],
    mor: ['pembe', 'gri'],
    kahverengi: ['vizon', 'bej', 'krem']
  };

  var STYLE_DEFINITIONS = [
    { name: 'modern', terms: ['modern', 'cagdas'] },
    { name: 'klasik', terms: ['klasik', 'classic', 'oriental', 'oryantal'] },
    { name: 'minimalist', terms: ['minimalist', 'minimal', 'sade'] },
    { name: 'bohem', terms: ['bohem', 'boho'] },
    { name: 'iskandinav', terms: ['iskandinav', 'scandinavian', 'nordic'] },
    { name: 'vintage', terms: ['vintage', 'eskitme', 'retro'] },
    { name: 'rustik', terms: ['rustik', 'rustic', 'dogal'] },
    { name: 'endüstriyel', terms: ['endustriyel', 'industrial'] },
    { name: 'etnik', terms: ['etnik', 'ethnic', 'kilim'] },
    { name: 'lüks', terms: ['luks', 'premium', 'exclusive'] }
  ];

  var PATTERN_DEFINITIONS = [
    { name: 'geometrik', terms: ['geometrik', 'geometric'] },
    { name: 'düz', terms: ['duz', 'plain', 'sade'] },
    { name: 'soyut', terms: ['soyut', 'abstract'] },
    { name: 'çiçekli', terms: ['cicek', 'floral'] },
    { name: 'etnik', terms: ['etnik', 'kilim', 'tribal'] },
    { name: 'mermer', terms: ['mermer', 'marble'] },
    { name: 'çizgili', terms: ['cizgili', 'stripe'] },
    { name: 'desenli', terms: ['desenli', 'pattern'] }
  ];

  function cleanText(value, maxLength) {
    var text = String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
    return text.slice(0, maxLength || 180);
  }

  function searchKey(value) {
    var text = cleanText(value, 5000).toLocaleLowerCase('tr-TR');
    if (typeof text.normalize === 'function') {
      text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }
    return text
      .replace(/ı/g, 'i')
      .replace(/ş/g, 's')
      .replace(/ğ/g, 'g')
      .replace(/ç/g, 'c')
      .replace(/ö/g, 'o')
      .replace(/ü/g, 'u')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function asArray(value, maxItems) {
    var source = [];
    if (Array.isArray(value)) source = value;
    else if (typeof value === 'string') source = value.split(/[,;|\n]+/);
    else if (value != null) source = [value];

    var seen = Object.create(null);
    var output = [];
    source.forEach(function (item) {
      var text = cleanText(item, 80);
      var key = searchKey(text);
      if (!text || !key || seen[key]) return;
      seen[key] = true;
      output.push(text);
    });
    return output.slice(0, maxItems || 12);
  }

  function finiteNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  function clamp(value, minimum, maximum) {
    return Math.max(minimum, Math.min(maximum, value));
  }

  function parseDimensions(value) {
    var text = cleanText(value, 180);
    var match = text.match(/^\s*(\d{2,3})\s*[xX×*]\s*(\d{2,3})\s*(?:cm)?\s*$/i);
    if (!match) return null;
    var first = finiteNumber(match[1]);
    var second = finiteNumber(match[2]);
    if (first == null || second == null || first < 40 || second < 40 || first > 600 || second > 600) return null;
    return {
      widthCm: Math.min(first, second),
      lengthCm: Math.max(first, second),
      label: Math.min(first, second) + '×' + Math.max(first, second) + ' cm'
    };
  }

  function confidenceLabel(value, score) {
    var key = searchKey(value);
    if (/yuksek|high/.test(key)) return 'yüksek';
    if (/orta|medium/.test(key)) return 'orta';
    if (/dusuk|low/.test(key)) return 'düşük';
    if (score >= 0.78) return 'yüksek';
    if (score >= 0.5) return 'orta';
    return 'düşük';
  }

  function normalizeEstimatedSize(raw, fallbackText) {
    var source = raw && typeof raw === 'object' && !Array.isArray(raw) ? raw : {};
    var parsedFallback = parseDimensions(fallbackText);
    var width = finiteNumber(source.widthCm != null ? source.widthCm : source.width_cm);
    var length = finiteNumber(source.lengthCm != null ? source.lengthCm : source.length_cm);
    if ((width == null || length == null) && parsedFallback) {
      width = parsedFallback.widthCm;
      length = parsedFallback.lengthCm;
    }
    if (width == null || length == null || width < 40 || length < 40 || width > 600 || length > 600) return null;
    var shorterSide = Math.min(width, length);
    var longerSide = Math.max(width, length);
    width = Math.round(shorterSide / 5) * 5;
    length = Math.round(longerSide / 5) * 5;
    var rawScore = finiteNumber(source.confidenceScore != null ? source.confidenceScore : source.confidence_score);
    var score = rawScore == null ? 0.55 : clamp(rawScore > 1 ? rawScore / 100 : rawScore, 0, 1);
    var status = searchKey(source.status || 'estimated');
    var scaleAnchor = searchKey(source.scaleAnchor || source.scale_anchor || 'none');
    var strongAnchor = /floor grid|tile grid|known object|measured reference|repeating floor|zemin izgara|fayans/.test(scaleAnchor);
    var mediumAnchor = /door|sofa|chair|desk|bed|kapi|koltuk|sandalye|masa|yatak/.test(scaleAnchor);
    var evidenceCap = strongAnchor ? 0.85 : mediumAnchor ? 0.64 : 0.49;
    var perspective = finiteNumber(source.perspectiveQuality != null ? source.perspectiveQuality : source.perspective_quality);
    var visibility = finiteNumber(source.floorVisibility != null ? source.floorVisibility : source.floor_visibility);
    perspective = perspective == null ? 0.9 : clamp(perspective > 1 ? perspective / 100 : perspective, 0.55, 1);
    visibility = visibility == null ? 0.9 : clamp(visibility > 1 ? visibility / 100 : visibility, 0.55, 1);
    var effectiveConfidence = status === 'insufficient evidence' || status === 'insufficient_evidence'
      ? Math.min(0.49, score)
      : clamp(Math.min(score, evidenceCap) * perspective * visibility, 0, 0.95);
    var matchMode = effectiveConfidence >= 0.78 && strongAnchor
      ? 'hard'
      : effectiveConfidence >= 0.52
        ? 'soft'
        : 'advisory';
    return {
      widthCm: width,
      lengthCm: length,
      label: width + '×' + length + ' cm',
      confidence: confidenceLabel('', effectiveConfidence),
      confidenceScore: effectiveConfidence,
      modelConfidenceScore: score,
      matchMode: matchMode,
      scaleAnchor: scaleAnchor,
      evidence: asArray(source.evidence || source.visualEvidence || source.visual_evidence, 4),
      basis: cleanText(source.basis || source.method, 180),
      limitations: asArray(source.limitations, 4)
    };
  }

  function confirmEstimatedSize(analysis, widthValue, lengthValue) {
    if (!analysis || typeof analysis !== 'object') return null;
    var width = finiteNumber(widthValue);
    var length = finiteNumber(lengthValue);
    if (width == null || length == null || width < 40 || length < 40 || width > 600 || length > 600) return null;
    width = Math.round(Math.min(width, length) / 5) * 5;
    length = Math.round(Math.max(widthValue, lengthValue) / 5) * 5;
    var confirmed = {
      widthCm: width,
      lengthCm: length,
      label: width + '×' + length + ' cm',
      confidence: 'müşteri doğruladı',
      confidenceScore: 0.95,
      modelConfidenceScore: analysis.estimatedRugSize ? analysis.estimatedRugSize.modelConfidenceScore : 0,
      matchMode: 'hard',
      scaleAnchor: 'user measured',
      evidence: ['Müşteri tarafından ölçülüp doğrulandı'],
      basis: 'Müşteri ölçüsü',
      limitations: [],
      userConfirmed: true
    };
    return Object.assign({}, analysis, {
      availableSpace: confirmed.label,
      estimatedRugSize: confirmed
    });
  }

  function containsTerm(haystack, term) {
    var padded = ' ' + haystack + ' ';
    return padded.indexOf(' ' + searchKey(term) + ' ') !== -1;
  }

  function labelsFromDefinitions(text, definitions) {
    var labels = [];
    definitions.forEach(function (definition) {
      var found = definition.terms.some(function (term) {
        return containsTerm(text, term);
      });
      if (found) labels.push(definition.name);
    });
    return labels;
  }

  function canonicalColor(value) {
    var key = searchKey(value);
    var match = COLOR_DEFINITIONS.find(function (definition) {
      return definition.terms.some(function (term) {
        return containsTerm(key, term) || key === searchKey(term);
      });
    });
    return match ? match.name : key;
  }

  function canonicalStyle(value) {
    var key = searchKey(value);
    var match = STYLE_DEFINITIONS.find(function (definition) {
      return definition.terms.some(function (term) {
        return containsTerm(key, term) || key === searchKey(term);
      });
    });
    return match ? match.name : key;
  }

  function canonicalPattern(value) {
    var key = searchKey(value);
    var match = PATTERN_DEFINITIONS.find(function (definition) {
      return definition.terms.some(function (term) {
        return containsTerm(key, term) || key === searchKey(term);
      });
    });
    return match ? match.name : key;
  }

  function canonicalRoom(value) {
    var key = searchKey(value);
    if (/cocuk|bebek|genc|children|child|kids|kid|nursery/.test(key)) return 'çocuk odası';
    if (/salon|oturma|living room|lounge/.test(key)) return 'salon';
    if (/yatak|bedroom/.test(key)) return 'yatak odası';
    if (/yemek|dining/.test(key)) return 'yemek odası';
    if (/koridor|antre|hol|hallway|corridor|entryway/.test(key)) return 'koridor';
    if (/mutfak|kitchen/.test(key)) return 'mutfak';
    if (/ofis|calisma|office|study/.test(key)) return 'ofis';
    if (/banyo|bathroom/.test(key)) return 'banyo';
    return cleanText(value, 50);
  }

  function canonicalShape(value) {
    var key = searchKey(value);
    if (/yuvarlak|daire|round/.test(key)) return 'yuvarlak';
    if (/oval/.test(key)) return 'oval';
    if (/yolluk|runner/.test(key)) return 'yolluk';
    return 'dikdörtgen';
  }

  function normalizeAnalysis(raw) {
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
      throw new Error('AI_ANALYSIS_INVALID');
    }

    var availableSpace = cleanText(raw.availableSpace || raw.available_space, 140);
    var estimatedSize = normalizeEstimatedSize(
      raw.estimatedRugSize || raw.estimated_rug_size || raw.rugSizeEstimate || raw.rug_size_estimate,
      availableSpace
    );
    var analysis = {
      roomType: canonicalRoom(raw.roomType || raw.room || raw.room_type),
      dominantColors: asArray(raw.dominantColors || raw.colors || raw.dominant_colors, 8),
      accentColors: asArray(raw.accentColors || raw.accent_colors, 6),
      style: cleanText(raw.style || raw.interiorStyle || raw.interior_style, 60),
      floorType: cleanText(raw.floorType || raw.floor || raw.floor_type, 60),
      furnitureStyle: cleanText(raw.furnitureStyle || raw.furniture_style, 60),
      lighting: cleanText(raw.lighting || raw.light, 100),
      childGender: cleanText(raw.childGender || raw.child_gender, 30),
      availableSpace: estimatedSize ? 'Yaklaşık ' + estimatedSize.label : availableSpace,
      estimatedRugSize: estimatedSize,
      recommendedShape: canonicalShape(raw.recommendedShape || raw.recommended_shape || raw.rugShape || raw.rug_shape),
      recommendedCarpetColors: asArray(
        raw.recommendedCarpetColors || raw.recommendedColors || raw.recommended_carpet_colors,
        8
      ),
      recommendedPatterns: asArray(raw.recommendedPatterns || raw.recommended_patterns, 8),
      avoidColors: asArray(raw.avoidColors || raw.avoid_colors, 8),
      reasoning: cleanText(raw.reasoning || raw.explanation || raw.summary, 700)
    };

    if (
      !analysis.roomType &&
      !analysis.style &&
      !analysis.reasoning &&
      analysis.dominantColors.length === 0 &&
      analysis.recommendedCarpetColors.length === 0
    ) {
      throw new Error('AI_ANALYSIS_EMPTY');
    }

    return analysis;
  }

  function extractFirstJsonObject(value) {
    var text = cleanText(value, 30000).replace(/^```(?:json)?\s*/i, '').replace(/\s*```$/i, '');
    var start = text.indexOf('{');
    if (start === -1) return null;

    var depth = 0;
    var inString = false;
    var escaped = false;
    for (var index = start; index < text.length; index += 1) {
      var character = text.charAt(index);
      if (inString) {
        if (escaped) escaped = false;
        else if (character === '\\') escaped = true;
        else if (character === '"') inString = false;
        continue;
      }
      if (character === '"') {
        inString = true;
        continue;
      }
      if (character === '{') depth += 1;
      if (character === '}') {
        depth -= 1;
        if (depth === 0) return text.slice(start, index + 1);
      }
    }
    return null;
  }

  function extractVisionContent(data) {
    if (!data || typeof data !== 'object') return null;
    if (data.analysis && typeof data.analysis === 'object') return data.analysis;
    if (typeof data.analysis === 'string') return data.analysis;
    if (typeof data.output_text === 'string') return data.output_text;

    var choiceContent = data.choices && data.choices[0] && data.choices[0].message
      ? data.choices[0].message.content
      : null;
    if (typeof choiceContent === 'string') return choiceContent;
    if (Array.isArray(choiceContent)) {
      var choiceText = choiceContent.map(function (part) {
        if (typeof part === 'string') return part;
        if (part && typeof part.text === 'string') return part.text;
        if (part && part.text && typeof part.text.value === 'string') return part.text.value;
        return '';
      }).join('\n').trim();
      if (choiceText) return choiceText;
    }

    if (Array.isArray(data.output)) {
      var outputText = [];
      data.output.forEach(function (item) {
        if (!item || !Array.isArray(item.content)) return;
        item.content.forEach(function (part) {
          if (part && typeof part.text === 'string') outputText.push(part.text);
        });
      });
      if (outputText.length) return outputText.join('\n');
    }
    return null;
  }

  function parseVisionAnalysis(data) {
    if (data && typeof data === 'object' && !Array.isArray(data) && (
      data.roomType || data.reasoning || data.recommendedCarpetColors
    )) {
      return normalizeAnalysis(data);
    }

    var content = extractVisionContent(data);
    if (content && typeof content === 'object') return normalizeAnalysis(content);
    if (typeof content !== 'string') throw new Error('AI_RESPONSE_EMPTY');
    var json = extractFirstJsonObject(content);
    if (!json) throw new Error('AI_RESPONSE_JSON_MISSING');
    try {
      return normalizeAnalysis(JSON.parse(json));
    } catch (error) {
      if (/^AI_/.test(error.message)) throw error;
      throw new Error('AI_RESPONSE_JSON_INVALID');
    }
  }

  function safeImageUrl(value, origin) {
    var url = cleanText(value, 1200);
    if (!url) return '';
    if (url.indexOf('//') === 0) return 'https:' + url;
    if (url.charAt(0) === '/') return (origin || '') + url;
    if (/^https:\/\//i.test(url)) return url;
    return '';
  }

  function safeProductPath(handle, variantId) {
    var safeHandle = cleanText(handle, 180);
    // A small set of existing Shopify handles contains Turkish combining
    // marks (for example the dotted capital I after lower-casing). Keep those
    // valid path segments while still rejecting slashes, protocols and markup.
    if (!/^[\p{L}\p{N}\p{M}][\p{L}\p{N}\p{M}-]*$/u.test(safeHandle)) return '';
    var id = cleanText(variantId, 40);
    if (!/^\d+$/.test(id)) return '';
    return '/products/' + encodeURIComponent(safeHandle) + '?variant=' + encodeURIComponent(id);
  }

  function deriveRooms(text) {
    var rooms = [];
    if (/cocuk|bebek|genc|kids/.test(text)) rooms.push('çocuk odası');
    if (/salon|oturma/.test(text)) rooms.push('salon');
    if (/yatak/.test(text)) rooms.push('yatak odası');
    if (/yemek/.test(text)) rooms.push('yemek odası');
    if (/koridor|antre|hol|yolluk/.test(text)) rooms.push('koridor');
    if (/mutfak/.test(text)) rooms.push('mutfak');
    if (/ofis|calisma/.test(text)) rooms.push('ofis');
    return rooms;
  }

  function deriveSeries(title) {
    var cleaned = cleanText(title, 180)
      .replace(/^dolce\s+vita\s+hal[iı]\s*/i, '')
      .replace(/^dolce\s+vita\s*/i, '')
      .trim();
    var first = cleaned.split(/\s+/)[0] || 'diğer';
    return searchKey(first) || 'diğer';
  }

  function deriveShape(value) {
    var key = searchKey(value);
    if (/yuvarlak|daire|round/.test(key)) return 'yuvarlak';
    if (/oval/.test(key)) return 'oval';
    if (/yolluk|runner/.test(key)) return 'yolluk';
    return 'dikdörtgen';
  }

  function isMassimoProduct(title, handle) {
    var key = ' ' + searchKey([title, handle].join(' ')) + ' ';
    return key.indexOf(' massimo ') !== -1;
  }

  function normalizeVariant(raw, origin, fallbackImage) {
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return null;
    var id = cleanText(raw.id, 40);
    var inventory = finiteNumber(raw.inventory != null ? raw.inventory : raw.inventoryQuantity);
    var price = finiteNumber(raw.priceCents != null ? raw.priceCents : raw.price);
    var compareAt = finiteNumber(raw.compareAtPriceCents != null ? raw.compareAtPriceCents : raw.compare_at_price) || 0;
    var title = cleanText(raw.title || raw.name, 120);
    var dimensions = parseDimensions(title);
    var image = safeImageUrl(raw.featuredImage || raw.featured_image, origin) || fallbackImage;
    if (!/^\d+$/.test(id) || raw.available !== true || inventory == null || inventory <= 0 || price == null || price <= 0 || !dimensions) {
      return null;
    }
    return {
      id: id,
      title: title,
      available: true,
      inventory: Math.floor(inventory),
      priceCents: Math.round(price),
      compareAtPriceCents: Math.round(compareAt),
      featuredImage: image,
      widthCm: dimensions.widthCm,
      lengthCm: dimensions.lengthCm,
      sizeLabel: dimensions.label
    };
  }

  function productWithVariant(product, variant, sizeFit) {
    var selected = Object.assign({}, product);
    selected.selectedVariantId = variant.id;
    selected.selectedVariantAvailable = true;
    selected.variantTitle = variant.title;
    selected.variantInventory = variant.inventory;
    selected.priceCents = variant.priceCents;
    selected.compareAtPriceCents = variant.compareAtPriceCents;
    selected.featuredImage = variant.featuredImage || product.featuredImage;
    selected.selectedSize = {
      widthCm: variant.widthCm,
      lengthCm: variant.lengthCm,
      label: variant.sizeLabel
    };
    selected.sizeFit = sizeFit || null;
    selected.url = safeProductPath(product.handle, variant.id);
    selected.hasDiscount = variant.compareAtPriceCents > variant.priceCents;
    selected.discountPercent = selected.hasDiscount
      ? Math.round((1 - variant.priceCents / variant.compareAtPriceCents) * 100)
      : 0;
    return selected;
  }

  function selectBestVariant(product, estimatedSize) {
    if (!product || !estimatedSize || !Array.isArray(product.inStockVariants)) return null;
    var targetWidth = estimatedSize.widthCm;
    var targetLength = estimatedSize.lengthCm;
    var targetArea = targetWidth * targetLength;
    var mode = estimatedSize.matchMode || 'advisory';
    var tolerance = mode === 'hard' ? 0.34 : mode === 'soft' ? 0.48 : 0.68;
    var minimumSideRatio = mode === 'hard' ? 0.7 : mode === 'soft' ? 0.58 : 0.45;
    var maximumSideRatio = mode === 'hard' ? 1.32 : mode === 'soft' ? 1.5 : 1.8;
    var minimumAreaRatio = mode === 'hard' ? 0.62 : mode === 'soft' ? 0.45 : 0.3;
    var maximumAreaRatio = mode === 'hard' ? 1.45 : mode === 'soft' ? 1.75 : 2.4;
    var maximumFitScore = mode === 'hard' ? 42 : mode === 'soft' ? 22 : 10;
    var candidates = [];

    product.inStockVariants.forEach(function (variant) {
      var widthRatio = variant.widthCm / targetWidth;
      var lengthRatio = variant.lengthCm / targetLength;
      var areaRatio = (variant.widthCm * variant.lengthCm) / targetArea;
      var widthError = Math.abs(1 - widthRatio);
      var lengthError = Math.abs(1 - lengthRatio);
      var areaError = Math.abs(1 - areaRatio);
      var weightedError = widthError * 0.34 + lengthError * 0.36 + areaError * 0.3;
      if (
        widthRatio < minimumSideRatio || widthRatio > maximumSideRatio ||
        lengthRatio < minimumSideRatio || lengthRatio > maximumSideRatio ||
        areaRatio < minimumAreaRatio || areaRatio > maximumAreaRatio ||
        weightedError > tolerance
      ) return;

      var exact = widthError <= 0.035 && lengthError <= 0.035;
      var close = weightedError <= 0.14;
      var widthDelta = Math.round(widthError * 100);
      var lengthDelta = Math.round(lengthError * 100);
      var sizeBasis = estimatedSize.userConfirmed ? 'Doğruladığınız' : 'Fotoğraftan tahmin edilen';
      candidates.push({
        variant: variant,
        weightedError: weightedError,
        fitScore: Math.round(clamp(maximumFitScore * (1 - weightedError / tolerance), 3, maximumFitScore)),
        fitLabel: exact ? 'tam yakın' : close ? 'çok yakın' : 'en yakın uygun',
        reason: exact
          ? sizeBasis + ' ' + estimatedSize.label + ' alan için stoktaki ' + variant.sizeLabel + ' ebat seçildi.'
          : sizeBasis + ' ' + estimatedSize.label + ' alana en yakın stoklu ebat ' + variant.sizeLabel +
            ' (kenar farkı yaklaşık %' + widthDelta + ' / %' + lengthDelta + ').'
      });
    });

    candidates.sort(function (left, right) {
      if (left.weightedError !== right.weightedError) return left.weightedError - right.weightedError;
      if (right.variant.inventory !== left.variant.inventory) return right.variant.inventory - left.variant.inventory;
      return left.variant.priceCents - right.variant.priceCents;
    });
    return candidates[0] || null;
  }

  function normalizeProduct(raw, origin) {
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return null;
    var id = finiteNumber(raw.id);
    var title = cleanText(raw.title, 220);
    var handle = cleanText(raw.handle, 180);
    var vendor = cleanText(raw.vendor, 80);
    var tags = asArray(raw.tags, 120);
    var tagKey = '|' + tags.map(searchKey).join('|') + '|';
    var image = safeImageUrl(raw.featuredImage, origin);

    if (
      !id || !title || !handle ||
      !/^(dolce vita|dolce vita hali)$/i.test(searchKey(vendor)) ||
      tagKey.indexOf('|hidden|') !== -1 ||
      tagKey.indexOf('|dpo linked|') !== -1 ||
      cleanText(raw.productKind, 40) !== 'fixed_piece' ||
      isMassimoProduct(title, handle)
    ) {
      return null;
    }

    var variants = (Array.isArray(raw.inStockVariants) ? raw.inStockVariants : [])
      .map(function (variant) { return normalizeVariant(variant, origin, image); })
      .filter(Boolean);
    if (!variants.length) return null;
    if (!safeProductPath(handle, variants[0].id)) return null;
    if (!image) image = variants[0].featuredImage;
    if (!image) return null;
    variants = variants.map(function (variant) {
      if (!variant.featuredImage) variant.featuredImage = image;
      return variant;
    });
    var inventory = variants.reduce(function (sum, variant) { return sum + variant.inventory; }, 0);

    var text = searchKey([title, raw.productType, vendor].concat(tags).join(' '));
    var colors = labelsFromDefinitions(text, COLOR_DEFINITIONS);
    var styles = labelsFromDefinitions(text, STYLE_DEFINITIONS);
    var patterns = labelsFromDefinitions(text, PATTERN_DEFINITIONS);
    var rooms = deriveRooms(text);
    var identityText = searchKey(title + ' ' + handle);
    var normalizedTags = tags.map(searchKey);
    // Broad SEO tags such as "mavi çocuk halısı" also exist on adult salon
    // rugs. Only an explicit Kids identity or exact child-room collection tag
    // is strong enough to classify a recommendation as a children's product.
    var isKids = containsTerm(identityText, 'kids') || [
      'cocuk odasi',
      'cocuk odasi halisi',
      'cocuk halilari'
    ].some(function (tag) { return normalizedTags.indexOf(tag) !== -1; });

    return {
      id: id,
      title: title,
      handle: handle,
      vendor: vendor,
      tags: tags,
      featuredImage: image,
      totalInventory: Math.floor(inventory),
      inStockVariants: variants,
      colors: colors,
      styles: styles,
      patterns: patterns,
      rooms: rooms,
      isKids: isKids,
      series: deriveSeries(title),
      shape: deriveShape([title, handle].concat(tags).join(' '))
    };
  }

  function validateCatalogPage(data) {
    if (!data || typeof data !== 'object' || Array.isArray(data)) return false;
    if (data.version !== CATALOG_VERSION || data.stockRule !== STOCK_RULE) return false;
    if (!Array.isArray(data.products) || typeof data.hasNextPage !== 'boolean') return false;
    var page = finiteNumber(data.page);
    var pages = finiteNumber(data.pages);
    if (page == null || pages == null || page < 1 || pages < page) return false;
    return true;
  }

  function roomMatches(product, room) {
    if (!room) return false;
    return product.rooms.indexOf(room) !== -1;
  }

  function scoreProducts(products, analysis) {
    if (!analysis || !analysis.estimatedRugSize) return [];
    if (analysis.estimatedRugSize.matchMode === 'advisory') return [];
    var desiredColors = analysis.recommendedCarpetColors.map(canonicalColor).filter(Boolean);
    var dominantColors = analysis.dominantColors.map(canonicalColor).filter(Boolean);
    var avoidColors = analysis.avoidColors.map(canonicalColor).filter(Boolean);
    var desiredStyle = canonicalStyle(analysis.style);
    var desiredPatterns = analysis.recommendedPatterns.map(canonicalPattern).filter(Boolean);
    var room = canonicalRoom(analysis.roomType);
    var childRoom = room === 'çocuk odası';
    var requestedShape = canonicalShape(analysis.recommendedShape);
    var scored = [];

    products.forEach(function (product) {
      if (!product || product.totalInventory <= 0 || !Array.isArray(product.inStockVariants)) return;
      if (childRoom && !product.isKids) return;
      if (!childRoom && product.isKids) return;
      if (requestedShape && product.shape !== requestedShape) return;

      var variantFit = selectBestVariant(product, analysis.estimatedRugSize);
      if (!variantFit) return;
      var selectedProduct = productWithVariant(product, variantFit.variant, variantFit);
      if (!selectedProduct.url) return;

      var score = variantFit.fitScore;
      var reasons = [variantFit.reason];
      var colorScore = 0;
      var matchedColors = [];

      desiredColors.forEach(function (color) {
        if (selectedProduct.colors.indexOf(color) !== -1) {
          colorScore += 11;
          if (matchedColors.indexOf(color) === -1) matchedColors.push(color);
          return;
        }
        (COLOR_NEIGHBOURS[color] || []).some(function (neighbour) {
          if (selectedProduct.colors.indexOf(neighbour) === -1) return false;
          colorScore += 5;
          if (matchedColors.indexOf(neighbour) === -1) matchedColors.push(neighbour);
          return true;
        });
      });
      dominantColors.forEach(function (color) {
        if (selectedProduct.colors.indexOf(color) !== -1) colorScore += 3;
      });
      avoidColors.forEach(function (color) {
        if (selectedProduct.colors.indexOf(color) !== -1) colorScore -= 24;
      });
      colorScore = Math.max(-24, Math.min(30, colorScore));
      score += colorScore;
      if (matchedColors.length) reasons.push('Doğrulanmış renk uyumu: ' + matchedColors.slice(0, 2).join(', '));

      if (roomMatches(selectedProduct, room)) {
        score += 12;
        reasons.push(room === 'çocuk odası' ? 'Çocuk odası koleksiyonuyla uyumlu' : cleanText(analysis.roomType, 50) + ' kullanımına uygun');
      } else if (selectedProduct.rooms.length === 0) {
        score += 3;
      }

      if (desiredStyle && selectedProduct.styles.indexOf(desiredStyle) !== -1) {
        score += 14;
        reasons.push('Ürün stili: ' + analysis.style);
      } else if (
        desiredStyle === 'modern' &&
        (selectedProduct.styles.indexOf('minimalist') !== -1 || selectedProduct.patterns.indexOf('geometrik') !== -1)
      ) {
        score += 8;
        reasons.push('Modern çizgiye yakın');
      } else if (
        desiredStyle === 'bohem' &&
        (selectedProduct.styles.indexOf('etnik') !== -1 || selectedProduct.styles.indexOf('vintage') !== -1)
      ) {
        score += 8;
        reasons.push('Bohem stile yakın');
      }

      var patternMatch = desiredPatterns.find(function (pattern) {
        return selectedProduct.patterns.indexOf(pattern) !== -1;
      });
      if (patternMatch) {
        score += 10;
        reasons.push('Ürün deseni: ' + patternMatch);
      }

      if (score >= 35 && reasons.length) {
        scored.push({
          product: selectedProduct,
          score: Math.min(96, Math.round(score)),
          reasons: reasons,
          sizeReason: variantFit.reason,
          visualVerified: false,
          visualReason: ''
        });
      }
    });

    scored.sort(function (left, right) {
      if (right.score !== left.score) return right.score - left.score;
      if (right.product.variantInventory !== left.product.variantInventory) {
        return right.product.variantInventory - left.product.variantInventory;
      }
      return left.product.title.localeCompare(right.product.title, 'tr');
    });

    var seriesCounts = Object.create(null);
    var finalResults = [];
    scored.forEach(function (match) {
      var series = match.product.series || 'diğer';
      if ((seriesCounts[series] || 0) >= 2) return;
      seriesCounts[series] = (seriesCounts[series] || 0) + 1;
      finalResults.push(match);
    });
    return finalResults.slice(0, VERIFY_POOL_SIZE);
  }

  function extractJsonPayload(data) {
    if (data && typeof data === 'object' && (Array.isArray(data.visualMatches) || Array.isArray(data.matches) || Array.isArray(data.ranked))) return data;
    if (data && data.analysis && typeof data.analysis === 'object') return data.analysis;
    var content = extractVisionContent(data);
    if (content && typeof content === 'object') return content;
    if (typeof content !== 'string') throw new Error('AI_RESPONSE_EMPTY');
    var json = extractFirstJsonObject(content);
    if (!json) throw new Error('AI_RESPONSE_JSON_MISSING');
    try {
      return JSON.parse(json);
    } catch (_) {
      throw new Error('AI_RESPONSE_JSON_INVALID');
    }
  }

  function normalizeVisualComparison(data, matches) {
    var payload = extractJsonPayload(data);
    var rows = payload.visualMatches || payload.matches || payload.ranked;
    if (!Array.isArray(rows)) throw new Error('VISUAL_RESPONSE_INVALID');
    var seen = Object.create(null);
    var normalized = [];
    rows.forEach(function (row) {
      if (!row || typeof row !== 'object') return;
      var index = finiteNumber(row.candidateIndex != null ? row.candidateIndex : row.index);
      var visualScore = finiteNumber(row.visualScore != null ? row.visualScore : row.score);
      if (index == null || Math.floor(index) !== index || index < 1 || index > matches.length || seen[index] || visualScore == null) return;
      var observedColors = asArray(row.observedColors || row.colors, 4)
        .map(canonicalColor)
        .filter(function (color) {
          return COLOR_DEFINITIONS.some(function (definition) { return definition.name === color; });
        });
      var observedPattern = canonicalPattern(row.observedPattern || row.pattern);
      if (!observedColors.length && !observedPattern) return;
      seen[index] = true;
      normalized.push({
        candidateIndex: Math.floor(index),
        visualScore: Math.round(clamp(visualScore, 0, 100)),
        observedColors: observedColors,
        observedPattern: observedPattern,
        concern: cleanText(row.concern, 180)
      });
    });
    if (!normalized.length) throw new Error('VISUAL_RESPONSE_EMPTY');
    return normalized;
  }

  function buildVerifiedVisualReason(row, analysis, product) {
    if (!row || !analysis || !product || cleanText(row.concern, 180)) return '';
    var productName = cleanText(product.title, 140)
      .replace(/^dolce\s+vita\s+hal[iı]\s*/i, '')
      .replace(/^dolce\s+vita\s*/i, '')
      .trim() || 'Bu ürün';
    var desiredColors = analysis.recommendedCarpetColors.map(canonicalColor).filter(Boolean);
    var desiredPatterns = analysis.recommendedPatterns.map(canonicalPattern).filter(Boolean);
    var avoidedColors = analysis.avoidColors.map(canonicalColor).filter(Boolean);
    var hasAvoidedColor = row.observedColors.some(function (color) {
      return avoidedColors.indexOf(color) !== -1;
    });
    if (hasAvoidedColor) return '';
    var matchedColors = row.observedColors.filter(function (color) {
      return desiredColors.indexOf(color) !== -1 || desiredColors.some(function (desired) {
        return (COLOR_NEIGHBOURS[desired] || []).indexOf(color) !== -1;
      });
    });
    var patternMatched = row.observedPattern && desiredPatterns.indexOf(row.observedPattern) !== -1;
    var observations = [];
    if (matchedColors.length) observations.push(matchedColors.slice(0, 2).join(' ve ') + ' tonları oda fotoğrafındaki önerilen paletle eşleşiyor');
    if (patternMatched) observations.push(row.observedPattern + ' desen oda için belirlenen desen yönüyle eşleşiyor');
    if (!observations.length) return '';
    return productName + ' ürün görselinde ' + observations.join('; ') + '.';
  }

  function mergeVisualRanking(matches, visualRows, analysis) {
    var byIndex = Object.create(null);
    visualRows.forEach(function (row) { byIndex[row.candidateIndex] = row; });
    var merged = [];
    matches.forEach(function (match, zeroIndex) {
      var row = byIndex[zeroIndex + 1];
      if (!row || row.visualScore < MIN_VISUAL_MATCH_SCORE || cleanText(row.concern, 180)) return;
      var verifiedReason = buildVerifiedVisualReason(row, analysis, match.product);
      if (!verifiedReason) return;
      merged.push(Object.assign({}, match, {
        score: Math.round(match.score * 0.48 + row.visualScore * 0.52),
        visualVerified: true,
        visualScore: row.visualScore,
        visualReason: verifiedReason,
        visualConcern: row.concern,
        reasons: [match.sizeReason, verifiedReason].concat(match.reasons.filter(function (reason) {
          return reason !== match.sizeReason;
        }))
      }));
    });
    merged.sort(function (left, right) {
      if (right.score !== left.score) return right.score - left.score;
      return left.product.title.localeCompare(right.product.title, 'tr');
    });
    return merged.slice(0, MAX_RECOMMENDATIONS);
  }

  function loadCanvasImage(source, allowCrossOrigin) {
    return new Promise(function (resolve, reject) {
      var image = new Image();
      var timer = setTimeout(function () {
        image.src = '';
        reject(new Error('VISUAL_IMAGE_TIMEOUT'));
      }, 12000);
      if (allowCrossOrigin) image.crossOrigin = 'anonymous';
      image.onload = function () {
        clearTimeout(timer);
        resolve(image);
      };
      image.onerror = function () {
        clearTimeout(timer);
        reject(new Error('VISUAL_IMAGE_LOAD_FAILED'));
      };
      image.src = source;
    });
  }

  function drawImageContained(context, image, x, y, width, height, cover) {
    var imageRatio = image.naturalWidth / image.naturalHeight;
    var boxRatio = width / height;
    var drawWidth;
    var drawHeight;
    if ((cover && imageRatio > boxRatio) || (!cover && imageRatio < boxRatio)) {
      drawHeight = height;
      drawWidth = height * imageRatio;
    } else {
      drawWidth = width;
      drawHeight = width / imageRatio;
    }
    context.save();
    context.beginPath();
    context.rect(x, y, width, height);
    context.clip();
    context.drawImage(image, x + (width - drawWidth) / 2, y + (height - drawHeight) / 2, drawWidth, drawHeight);
    context.restore();
  }

  function createVisualComparisonSheet(roomImagePayload, matches) {
    var candidates = matches.slice(0, VISUAL_POOL_SIZE).map(function (match, index) {
      return { match: match, candidateIndex: index + 1 };
    });
    return Promise.all([
      loadCanvasImage(roomImagePayload, false),
      Promise.all(candidates.map(function (candidate) {
        return loadCanvasImage(candidate.match.product.featuredImage, true)
          .then(function (image) { return Object.assign({}, candidate, { image: image }); })
          .catch(function () { return null; });
      }))
    ]).then(function (loaded) {
      var roomImage = loaded[0];
      var loadedCandidates = loaded[1].filter(Boolean);
      if (loadedCandidates.length < 3) throw new Error('VISUAL_SHEET_IMAGES_EMPTY');
      var canvas = document.createElement('canvas');
      canvas.width = 1600;
      canvas.height = 1200;
      var context = canvas.getContext('2d');
      if (!context) throw new Error('VISUAL_CANVAS_UNAVAILABLE');
      context.fillStyle = '#f5f1eb';
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.fillStyle = '#ffffff';
      context.fillRect(0, 0, 700, 1200);
      drawImageContained(context, roomImage, 0, 0, 700, 1200, true);
      context.fillStyle = 'rgba(24,22,20,.88)';
      context.fillRect(24, 24, 118, 54);
      context.fillStyle = '#ffffff';
      context.font = '700 28px Arial, sans-serif';
      context.fillText('ODA', 48, 61);

      var gridX = 720;
      var cellWidth = Math.floor((1600 - gridX) / 3);
      var cellHeight = 400;
      loadedCandidates.slice(0, 9).forEach(function (candidate, position) {
        var column = position % 3;
        var row = Math.floor(position / 3);
        var x = gridX + column * cellWidth + 8;
        var y = row * cellHeight + 8;
        context.fillStyle = '#ffffff';
        context.fillRect(x, y, cellWidth - 16, cellHeight - 16);
        drawImageContained(context, candidate.image, x + 12, y + 58, cellWidth - 40, cellHeight - 82, false);
        context.fillStyle = '#1e1b18';
        context.font = '700 28px Arial, sans-serif';
        context.fillText('A' + candidate.candidateIndex, x + 16, y + 38);
      });
      var payload;
      try {
        payload = canvas.toDataURL('image/jpeg', 0.84);
      } catch (_) {
        throw new Error('VISUAL_CANVAS_TAINTED');
      }
      return { payload: payload, candidates: loadedCandidates.slice(0, 9) };
    });
  }

  function visualComparisonPrompt(analysis, matches, candidates) {
    var candidateLines = candidates.map(function (candidate) {
      var match = matches[candidate.candidateIndex - 1];
      return 'A' + candidate.candidateIndex + ': ' + match.product.title + '; doğrulanmış stoklu ebat ' + match.product.selectedSize.label + '.';
    });
    return [
      'Tek görselde solda ODA, sağda A1-A9 etiketli gerçek halı ürün görselleri var.',
      'Bir iç mimar gibi yalnızca gördüğün renk paleti, desen yoğunluğu, desen ölçeği ve stil ilişkisine göre her adayı oda ile karşılaştır.',
      'Ürün fiyatı, stok adedi veya ölçüsü hakkında çıkarım yapma; aşağıdaki ölçüler sistem tarafından önceden doğrulandı.',
      'Her aday için yalnızca görselde gördüğün ana renkleri ve desen türünü seç. Görmediğin özelliği uydurma.',
      'visualScore 70 ve üzeri yalnız ürünün gerçek paleti/deseni oda ile güçlü biçimde uyumluysa ver; genel veya belirsiz benzerlik 70 altında kalmalı.',
      'Renk/desen çatışması, aşırı yoğunluk veya başka maddi uyumsuzluk varsa concern alanına kısa ve somut nedeni yaz; sorun yoksa boş bırak.',
      'Oda özeti: ' + cleanText(analysis.reasoning, 500),
      'Önerilen palet: ' + analysis.recommendedCarpetColors.join(', ') + '. Önerilen desen: ' + analysis.recommendedPatterns.join(', ') + '.',
      candidateLines.join('\n'),
      'Yalnızca geçerli JSON döndür: {"visualMatches":[{"candidateIndex":1,"visualScore":0,"observedColors":["bej"],"observedPattern":"geometrik","concern":""}]}'
    ].join('\n');
  }

  function requestVisualRanking(url, roomImagePayload, matches, analysis) {
    return createVisualComparisonSheet(roomImagePayload, matches).then(function (sheet) {
      return fetchWithTimeout(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          imageUrl: sheet.payload,
          prompt: visualComparisonPrompt(analysis, matches, sheet.candidates),
          model: 'gpt-4-turbo',
          maxTokens: 1500,
          temperature: 0.1
        })
      }, 70000).then(function (response) {
        if (!response.ok) throw new Error('VISUAL_HTTP_' + response.status);
        return response.json();
      }).then(function (data) {
        return mergeVisualRanking(matches, normalizeVisualComparison(data, matches), analysis);
      });
    });
  }

  function findScope(node) {
    if (!node || typeof node.closest !== 'function') return null;
    return node.closest('[data-dv-ai-room-v5]') || node.closest('.pbr-modal-body');
  }

  function getConfig(scope) {
    var config = scope && scope.querySelector ? scope.querySelector('[data-dv-ai-config]') : null;
    var source = config || scope;
    return {
      currentProductId: finiteNumber(source && source.dataset ? source.dataset.currentProductId : null),
      catalogUrl: cleanText(source && source.dataset ? source.dataset.catalogUrl : '', 500) || DEFAULT_CATALOG_URL,
      visionUrl: cleanText(source && source.dataset ? source.dataset.visionUrl : '', 500) || DEFAULT_VISION_URL
    };
  }

  function getNodes(scope) {
    if (!scope || typeof scope.querySelector !== 'function') return null;
    var nodes = {
      input: scope.querySelector('#ai-v4-file-input'),
      upload: scope.querySelector('#ai-v4-upload-btn'),
      preview: scope.querySelector('#ai-v4-preview'),
      previewImage: scope.querySelector('#ai-v4-preview-img'),
      loading: scope.querySelector('#ai-v4-loading'),
      loadingText: scope.querySelector('#ai-v4-loading-text'),
      loadingStep: scope.querySelector('#ai-v4-loading-step'),
      results: scope.querySelector('#ai-v4-results')
    };
    if (!nodes.input || !nodes.upload || !nodes.preview || !nodes.previewImage || !nodes.loading || !nodes.results) {
      return null;
    }
    return nodes;
  }

  function getState(scope) {
    var state = stateByScope && stateByScope.get(scope);
    if (!state) {
      state = { runId: 0, analysis: null, imagePayload: '' };
      if (stateByScope) stateByScope.set(scope, state);
    }
    return state;
  }

  function setHidden(node, hidden) {
    if (!node) return;
    node.hidden = Boolean(hidden);
    node.setAttribute('aria-hidden', hidden ? 'true' : 'false');
  }

  function setLoading(nodes, visible, title, detail) {
    setHidden(nodes.loading, !visible);
    if (nodes.loadingText) nodes.loadingText.textContent = title || '';
    if (nodes.loadingStep) nodes.loadingStep.textContent = detail || '';
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = String(text);
    return node;
  }

  function appendFact(parent, label, value) {
    if (!value) return;
    var fact = element('div', 'ai-v5-fact');
    fact.appendChild(element('small', '', label));
    fact.appendChild(element('span', '', value));
    parent.appendChild(fact);
  }

  function analysisCard(analysis) {
    var card = element('section', 'ai-v5-analysis');
    var top = element('div', 'ai-v5-analysis-top');
    top.appendChild(element('h4', '', 'Oda analiziniz hazır'));
    top.appendChild(element('span', 'ai-v5-complete', 'ANALİZ TAMAMLANDI'));
    card.appendChild(top);

    var facts = element('div', 'ai-v5-facts');
    appendFact(facts, 'ODA', analysis.roomType);
    appendFact(facts, 'STİL', analysis.style);
    appendFact(facts, 'ZEMİN', analysis.floorType);
    appendFact(facts, 'IŞIK', analysis.lighting);
    appendFact(facts, 'BASKIN RENKLER', analysis.dominantColors.slice(0, 4).join(', '));
    appendFact(facts, analysis.estimatedRugSize && analysis.estimatedRugSize.userConfirmed ? 'DOĞRULANAN HALI ALANI' : 'TAHMİNİ HALI ALANI', analysis.availableSpace);
    appendFact(facts, 'ÖNERİLEN ŞEKİL', analysis.recommendedShape);
    if (analysis.estimatedRugSize) {
      appendFact(facts, 'ÖLÇÜ GÜVENİ', analysis.estimatedRugSize.confidence);
    }
    card.appendChild(facts);

    if (analysis.reasoning) card.appendChild(element('p', 'ai-v5-reason', analysis.reasoning));
    if (analysis.estimatedRugSize) {
      card.appendChild(element(
        'p',
        'ai-v5-size-note',
        analysis.estimatedRugSize.userConfirmed
          ? 'Verdiğiniz ölçüye göre uygun ebatları seçtik.'
          : 'Ölçü, fotoğraftaki ölçek ve perspektife göre tahmindir; siparişten önce alanınızı ölçerek doğrulayın.'
      ));
      if (analysis.estimatedRugSize.evidence.length) {
        card.appendChild(element(
          'p',
          'ai-v5-size-evidence',
          'Tahmin dayanağı: ' + analysis.estimatedRugSize.evidence.slice(0, 2).join(' · ')
        ));
      }
    }
    var chips = element('div', 'ai-v5-palette');
    analysis.recommendedCarpetColors.forEach(function (color) {
      chips.appendChild(element('span', 'ai-v5-chip', 'Önerilen renk · ' + color));
    });
    analysis.recommendedPatterns.forEach(function (pattern) {
      chips.appendChild(element('span', 'ai-v5-chip', 'Önerilen desen · ' + pattern));
    });
    if (chips.childNodes.length) card.appendChild(chips);
    return card;
  }

  function formatMoney(cents) {
    var amount = Number(cents) / 100;
    try {
      return new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: 'TRY',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (_) {
      return amount.toFixed(2).replace('.', ',') + ' TL';
    }
  }

  function productCard(match, index) {
    var product = match.product;
    var card = element('article', 'ai-v5-product' + (index < 3 ? ' is-top' : ''));
    card.appendChild(element(
      'span',
      'ai-v5-score',
      'GÖRSEL + ÖLÇÜ + STOK UYUMU'
    ));

    var media = element('a', 'ai-v5-product-media');
    media.href = product.url;
    media.setAttribute('aria-label', product.title + ' ürününü incele');
    var image = element('img');
    image.src = product.featuredImage;
    image.alt = product.title;
    image.loading = 'lazy';
    image.decoding = 'async';
    media.appendChild(image);
    card.appendChild(media);

    var copy = element('div', 'ai-v5-product-copy');
    copy.appendChild(element(
      'span',
      'ai-v5-stock',
      product.variantInventory <= 5 ? 'SON ' + product.variantInventory + ' ADET' : 'STOKTA'
    ));
    var title = element('a', 'ai-v5-product-title', product.title);
    title.href = product.url;
    copy.appendChild(title);
    copy.appendChild(element('span', 'ai-v5-size-badge', 'Seçilen ebat · ' + product.selectedSize.label));
    var why = element('div', 'ai-v5-why');
    why.appendChild(element('h5', '', 'Neden bu ürün?'));
    var reasonList = element('ul');
    var visibleReasons = [match.sizeReason, match.visualReason].filter(Boolean);
    visibleReasons.slice(0, 2).forEach(function (reason) {
      reasonList.appendChild(element('li', '', reason));
    });
    why.appendChild(reasonList);
    copy.appendChild(why);

    var priceRow = element('div', 'ai-v5-price-row');
    priceRow.appendChild(element('span', 'ai-v5-price', formatMoney(product.priceCents)));
    if (product.hasDiscount) {
      priceRow.appendChild(element('span', 'ai-v5-compare', formatMoney(product.compareAtPriceCents)));
      priceRow.appendChild(element('span', 'ai-v5-discount', '%' + product.discountPercent));
    }
    copy.appendChild(priceRow);
    copy.appendChild(element('span', 'ai-v5-installment', formatMoney(product.priceCents / 6) + ' × 6 taksit'));
    var action = element('a', 'ai-v5-action', 'Ürünü incele');
    action.href = product.url;
    copy.appendChild(action);
    card.appendChild(copy);
    return card;
  }

  function renderView(scope, analysis, options) {
    var nodes = getNodes(scope);
    if (!nodes) return;
    while (nodes.results.firstChild) nodes.results.removeChild(nodes.results.firstChild);
    nodes.results.appendChild(analysisCard(analysis));

    if (options && options.status) {
      nodes.results.appendChild(element('div', 'ai-v5-catalog-state', options.status));
    }

    var matches = options && Array.isArray(options.matches)
      ? options.matches.filter(function (match) {
        return match && match.visualVerified === true && match.product && match.product.variantInventory > 0;
      })
      : [];
    if (matches.length) {
      var head = element('div', 'ai-v5-products-head');
      var headCopy = element('div');
      headCopy.appendChild(element('h4', 'ai-v5-products-title', 'Odanızla görsel olarak eşleşen stokta ürünler'));
      headCopy.appendChild(element('p', '', 'Odanızla uyumu, ebatı ve fiyatı kontrol ettik; bu halı hemen gönderilebilir.'));
      head.appendChild(headCopy);
      head.appendChild(element('span', 'ai-v5-file-note', matches.length + ' öneri'));
      nodes.results.appendChild(head);
      var grid = element('div', 'ai-v5-product-grid');
      matches.forEach(function (match, index) {
        grid.appendChild(productCard(match, index));
      });
      nodes.results.appendChild(grid);
    } else if (options && options.empty) {
      var empty = element('div', 'ai-v5-empty');
      empty.appendChild(element('div', '', options.empty));
      if (options.confirmSize && analysis.estimatedRugSize) {
        var confirmation = element('div', 'ai-v5-size-confirm');
        confirmation.appendChild(element('strong', '', 'Ölçüyü doğrulayın'));
        confirmation.appendChild(element('p', '', 'Tahmini değeri odanızda ölçün; gerekirse en ve boyu düzeltin.'));
        var fields = element('div', 'ai-v5-size-fields');
        var widthLabel = element('label', '', 'En (cm)');
        var widthInput = element('input');
        widthInput.type = 'number';
        widthInput.min = '40';
        widthInput.max = '600';
        widthInput.step = '5';
        widthInput.value = String(analysis.estimatedRugSize.widthCm);
        widthInput.setAttribute('data-dv-ai-size-width', 'true');
        widthLabel.appendChild(widthInput);
        var lengthLabel = element('label', '', 'Boy (cm)');
        var lengthInput = element('input');
        lengthInput.type = 'number';
        lengthInput.min = '40';
        lengthInput.max = '600';
        lengthInput.step = '5';
        lengthInput.value = String(analysis.estimatedRugSize.lengthCm);
        lengthInput.setAttribute('data-dv-ai-size-length', 'true');
        lengthLabel.appendChild(lengthInput);
        fields.appendChild(widthLabel);
        fields.appendChild(lengthLabel);
        confirmation.appendChild(fields);
        var confirmButton = element('button', 'ai-v5-confirm-size', 'Ölçüyü doğruladım, ürünleri göster');
        confirmButton.type = 'button';
        confirmButton.setAttribute('data-dv-ai-confirm-size', 'true');
        confirmation.appendChild(confirmButton);
        empty.appendChild(confirmation);
      }
      if (options.retry) {
        var retry = element('button', 'ai-v5-retry', 'Ürünleri yeniden kontrol et');
        retry.type = 'button';
        retry.setAttribute('data-dv-ai-retry', 'true');
        empty.appendChild(retry);
      }
      nodes.results.appendChild(empty);
    }
    setHidden(nodes.results, false);
  }

  function friendlyError(error) {
    var code = error && error.message ? error.message : '';
    if (/VISION_HTTP|AI_RESPONSE|AI_ANALYSIS/.test(code)) {
      return 'Fotoğraf analizi şu anda tamamlanamadı. Lütfen farklı bir fotoğrafla yeniden deneyin.';
    }
    if (/CATALOG|PRODUCT_VERIFY/.test(code)) {
      return 'Oda analizi tamamlandı; stoktaki ürün önerileri şu anda alınamadı. Biraz sonra yeniden kontrol edebilirsiniz.';
    }
    if (/VISUAL/.test(code)) {
      return 'Oda analizi tamamlandı; ürün görselleri güvenli biçimde karşılaştırılamadı. Yanlış ürün göstermemek için öneri sunmuyoruz; lütfen yeniden kontrol edin.';
    }
    return 'Beklenmeyen bir sorun oluştu. Lütfen yeniden deneyin.';
  }

  function renderFatal(scope, message) {
    var nodes = getNodes(scope);
    if (!nodes) return;
    setLoading(nodes, false);
    while (nodes.results.firstChild) nodes.results.removeChild(nodes.results.firstChild);
    nodes.results.appendChild(element('div', 'ai-v5-empty', message));
    setHidden(nodes.results, false);
  }

  function resizeImage(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onerror = function () { reject(new Error('IMAGE_READ_FAILED')); };
      reader.onload = function (event) {
        var image = new Image();
        image.onerror = function () { reject(new Error('IMAGE_DECODE_FAILED')); };
        image.onload = function () {
          if (!image.naturalWidth || !image.naturalHeight) {
            reject(new Error('IMAGE_DIMENSIONS_INVALID'));
            return;
          }
          var maxSize = 1280;
          var scale = Math.min(1, maxSize / Math.max(image.naturalWidth, image.naturalHeight));
          var canvas = document.createElement('canvas');
          canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
          canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
          var context = canvas.getContext('2d');
          context.fillStyle = '#ffffff';
          context.fillRect(0, 0, canvas.width, canvas.height);
          context.drawImage(image, 0, 0, canvas.width, canvas.height);
          resolve({ preview: event.target.result, payload: canvas.toDataURL('image/jpeg', 0.84) });
        };
        image.src = event.target.result;
      };
      reader.readAsDataURL(file);
    });
  }

  function visionPrompt() {
    return [
      'Sen deneyimli bir iç mimar ve halı uzmanısın. Oda fotoğrafını somut görsel kanıtlara dayanarak analiz et.',
      'Oda tipi, baskın ve vurgu renkleri, stil, zemin, mobilya stili, ışık, önerilen halı renkleri, desen ve şekli belirle.',
      'Halı alanının kısa ve uzun kenarını yalnız görünür zemin sınırı ve ölçek dayanağına göre santimetre olarak tahmin et. Tek fotoğrafta kesin ölçüm yapılamayacağını unutma.',
      'scaleAnchor yalnız floor_grid, tile_grid, known_object, door_standard, sofa_standard, furniture_standard veya none olabilir. Güçlü bir dayanak yoksa status=insufficient_evidence yaz ve confidenceScore 0.49 değerini aşmasın.',
      'widthCm kısa kenar, lengthCm uzun kenar olmalı; 40-600 cm dışında değer verme. perspectiveQuality ve floorVisibility 0-1 aralığında olmalı.',
      'Görmediğin ayrıntıları uydurma. evidence alanına tahmini destekleyen en fazla 3 kısa Türkçe gözlem yaz. Gerekçeyi müşterinin anlayacağı 2-3 Türkçe cümleyle yaz.',
      'Yalnızca şu anahtarlarla geçerli JSON döndür:',
      '{"roomType":"salon","dominantColors":["gri","bej"],"accentColors":["mavi"],"style":"modern","floorType":"parke","furnitureStyle":"modern","lighting":"doğal ışık","childGender":null,"availableSpace":"160x230 cm civarı","estimatedRugSize":{"status":"estimated","widthCm":160,"lengthCm":230,"confidenceScore":0.64,"scaleAnchor":"sofa_standard","perspectiveQuality":0.85,"floorVisibility":0.8,"evidence":["Koltuk ön kenarı ve geçiş hattı görünür"],"limitations":["Tek açı perspektifi"],"basis":"Görünür mobilya ve boş zemin oranı"},"recommendedShape":"dikdörtgen","recommendedCarpetColors":["bej","gri"],"recommendedPatterns":["geometrik","düz"],"avoidColors":["turuncu"],"reasoning":"..."}'
    ].join('\n');
  }

  function fetchWithTimeout(url, options, timeoutMs) {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = null;
    var requestOptions = Object.assign({}, options || {});
    if (controller) {
      requestOptions.signal = controller.signal;
      timer = setTimeout(function () { controller.abort(); }, timeoutMs || 60000);
    }
    return fetch(url, requestOptions).finally(function () {
      if (timer) clearTimeout(timer);
    });
  }

  function requestVision(url, imagePayload) {
    return fetchWithTimeout(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        imageUrl: imagePayload,
        prompt: visionPrompt(),
        model: 'gpt-4-turbo',
        maxTokens: 1200,
        temperature: 0.2
      })
    }, 70000).then(function (response) {
      if (!response.ok) throw new Error('VISION_HTTP_' + response.status);
      return response.json();
    }).then(parseVisionAnalysis);
  }

  function addQuery(url, key, value) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + encodeURIComponent(key) + '=' + encodeURIComponent(value);
  }

  function fetchCatalog(config) {
    var page = 1;
    var productsById = Object.create(null);
    var products = [];
    var origin = typeof window !== 'undefined' && window.location ? window.location.origin : '';

    function nextPage() {
      if (page > MAX_CATALOG_PAGES) throw new Error('CATALOG_PAGE_LIMIT');
      var pageUrl = addQuery(config.catalogUrl, 'page', page);
      pageUrl = addQuery(pageUrl, '_dv_ai_stock', Date.now() + '-' + page);
      return fetchWithTimeout(pageUrl, {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        // Shopify resolves alternate Liquid collection views through HTML
        // content negotiation even when the template body itself is JSON.
        // Asking for application/json bypasses the Liquid view and returns a
        // storefront 404, which previously left the analysis visible but
        // prevented every product recommendation from loading.
        headers: { Accept: 'text/html,application/xhtml+xml' }
      }, 30000).then(function (response) {
        if (!response.ok) throw new Error('CATALOG_HTTP_' + response.status);
        return response.text();
      }).then(function (body) {
        var data;
        try {
          data = JSON.parse(body);
        } catch (_) {
          throw new Error('CATALOG_JSON_INVALID');
        }
        if (!validateCatalogPage(data)) throw new Error('CATALOG_CONTRACT_INVALID');
        data.products.forEach(function (raw) {
          var product = normalizeProduct(raw, origin);
          if (!product || product.id === config.currentProductId || productsById[product.id]) return;
          productsById[product.id] = true;
          products.push(product);
        });
        if (data.hasNextPage) {
          page += 1;
          return nextPage();
        }
        if (!products.length) throw new Error('CATALOG_EMPTY');
        return products;
      });
    }

    return nextPage();
  }

  function verifyProduct(match) {
    var product = match.product;
    var verifyUrl = '/products/' + encodeURIComponent(product.handle) + '.js?_dv_ai_verify=' + Date.now();
    return fetchWithTimeout(verifyUrl, {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }, 15000).then(function (response) {
      if (!response.ok) return null;
      return response.json();
    }).then(function (data) {
      if (!data || !Array.isArray(data.variants)) return null;
      var variant = data.variants.find(function (candidate) {
        return String(candidate.id) === String(product.selectedVariantId);
      });
      if (!variant || variant.available !== true) return null;
      var liveDimensions = parseDimensions(variant.title);
      if (
        !liveDimensions || !product.selectedSize ||
        liveDimensions.widthCm !== product.selectedSize.widthCm ||
        liveDimensions.lengthCm !== product.selectedSize.lengthCm
      ) return null;
      var livePrice = finiteNumber(variant.price);
      if (livePrice == null || livePrice <= 0) return null;
      var liveCompare = finiteNumber(variant.compare_at_price) || 0;
      var liveImage = product.featuredImage;
      if (variant.featured_image && typeof variant.featured_image === 'object') {
        liveImage = safeImageUrl(variant.featured_image.src, window.location.origin) || liveImage;
      } else if (data.featured_image) {
        liveImage = safeImageUrl(data.featured_image, window.location.origin) || liveImage;
      }
      product.priceCents = Math.round(livePrice);
      product.compareAtPriceCents = Math.round(liveCompare);
      product.featuredImage = liveImage;
      product.variantTitle = cleanText(variant.title, 120);
      product.selectedSize = liveDimensions;
      product.hasDiscount = liveCompare > livePrice;
      product.discountPercent = product.hasDiscount ? Math.round((1 - livePrice / liveCompare) * 100) : 0;
      product.url = safeProductPath(product.handle, product.selectedVariantId);
      return match;
    }).catch(function () {
      return null;
    });
  }

  function verifyMatches(matches, limit) {
    var pool = matches.slice(0, VERIFY_POOL_SIZE);
    return Promise.all(pool.map(verifyProduct)).then(function (verified) {
      var available = verified.filter(Boolean).slice(0, limit || MAX_RECOMMENDATIONS);
      if (!available.length && pool.length) throw new Error('PRODUCT_VERIFY_EMPTY');
      return available;
    });
  }

  function revalidatePositiveStock(matches, products) {
    var byProductId = Object.create(null);
    (Array.isArray(products) ? products : []).forEach(function (product) {
      byProductId[String(product.id)] = product;
    });
    return (Array.isArray(matches) ? matches : []).map(function (match) {
      if (!match || !match.visualVerified || !match.product) return null;
      var freshProduct = byProductId[String(match.product.id)];
      if (!freshProduct || !Array.isArray(freshProduct.inStockVariants)) return null;
      var freshVariant = freshProduct.inStockVariants.find(function (variant) {
        return String(variant.id) === String(match.product.selectedVariantId) && variant.available === true && variant.inventory > 0;
      });
      if (!freshVariant) return null;
      var nextProduct = Object.assign({}, match.product, {
        variantInventory: freshVariant.inventory,
        priceCents: freshVariant.priceCents,
        compareAtPriceCents: freshVariant.compareAtPriceCents,
        featuredImage: freshVariant.featuredImage || match.product.featuredImage,
        hasDiscount: freshVariant.compareAtPriceCents > freshVariant.priceCents,
        discountPercent: freshVariant.compareAtPriceCents > freshVariant.priceCents
          ? Math.round((1 - freshVariant.priceCents / freshVariant.compareAtPriceCents) * 100)
          : 0
      });
      return Object.assign({}, match, { product: nextProduct });
    }).filter(Boolean);
  }

  function loadRecommendations(scope, analysis, runId, imagePayload) {
    var nodes = getNodes(scope);
    var state = getState(scope);
    var config = getConfig(scope);
    if (!nodes || state.runId !== runId) return Promise.resolve();
    if (!analysis.estimatedRugSize) {
      setLoading(nodes, false);
      renderView(scope, analysis, {
        empty: 'Fotoğrafta güvenli bir halı alanı tahmini çıkarılamadı. Zemini ve mobilya sınırlarını daha geniş gösteren bir fotoğrafla yeniden deneyin.'
      });
      return Promise.resolve();
    }
    if (analysis.estimatedRugSize.matchMode === 'advisory') {
      setLoading(nodes, false);
      renderView(scope, analysis, {
        empty: 'Fotoğraftan ölçü tahmini yanıltabilir. Yanlış ebat önermemek için önce odanızın ölçüsünü onaylamanızı istiyoruz.',
        confirmSize: true
      });
      return Promise.resolve();
    }
    setLoading(nodes, true, 'Stoktaki ürünler taranıyor…', 'Size uygun ebat ve fiyatlar hazırlanıyor');
    renderView(scope, analysis, { status: 'Burada yalnız hazır ebatta, stokta olan halılar var. Odanıza tam ölçü gerekiyorsa özel ölçü seçeneğine geçebilirsiniz.' });

    return fetchCatalog(config)
      .then(function (products) {
        if (state.runId !== runId) return [];
        var scored = scoreProducts(products, analysis);
        if (!scored.length) return [];
        return verifyMatches(scored, VISUAL_POOL_SIZE);
      })
      .then(function (verifiedMatches) {
        if (state.runId !== runId || !verifiedMatches.length) return verifiedMatches;
        if (!imagePayload) throw new Error('VISUAL_IMAGE_MISSING');
        setLoading(nodes, true, 'Ürün görselleri karşılaştırılıyor…', 'Oda fotoğrafı ile stoklu halı görselleri birlikte değerlendiriliyor');
        return requestVisualRanking(config.visionUrl, imagePayload, verifiedMatches, analysis)
          .catch(function (error) {
            console.warn('[DV-AI-V5.4] Visual comparison unavailable:', error.message);
            throw new Error('VISUAL_COMPARE_UNAVAILABLE');
          });
      })
      .then(function (visuallyVerifiedMatches) {
        if (state.runId !== runId || !visuallyVerifiedMatches.length) return visuallyVerifiedMatches;
        setLoading(nodes, true, 'Son stok kontrolü yapılıyor…', 'Ebat ve stok son kez kontrol ediliyor');
        return fetchCatalog(config).then(function (freshProducts) {
          var stockVerified = revalidatePositiveStock(visuallyVerifiedMatches, freshProducts);
          return verifyMatches(stockVerified, MAX_RECOMMENDATIONS);
        });
      })
      .then(function (matches) {
        if (state.runId !== runId) return;
        setLoading(nodes, false);
        if (matches.length) {
          renderView(scope, analysis, { matches: matches });
        } else {
          renderView(scope, analysis, {
            empty: 'Yanlış ürün göstermemek için yalnızca güçlü görsel eşleşmeleri listeliyoruz; bu fotoğrafta uygun ebatta, pozitif stoklu ve görsel olarak doğrulanmış bir eşleşme bulunamadı.'
          });
        }
      })
      .catch(function (error) {
        if (state.runId !== runId) return;
        console.error('[DV-AI-V5] Product recommendation failed:', error.message);
        setLoading(nodes, false);
        renderView(scope, analysis, { empty: friendlyError(error), retry: true });
      });
  }

  function startAnalysis(scope, imagePayload) {
    var nodes = getNodes(scope);
    if (!nodes) return;
    var state = getState(scope);
    state.runId += 1;
    state.analysis = null;
    state.imagePayload = imagePayload;
    var runId = state.runId;
    var config = getConfig(scope);
    setHidden(nodes.results, true);
    setLoading(nodes, true, 'Odanız analiz ediliyor…', 'Renk, stil, zemin ve ışık değerlendiriliyor');

    requestVision(config.visionUrl, imagePayload)
      .then(function (analysis) {
        if (state.runId !== runId) return;
        state.analysis = analysis;
        renderView(scope, analysis, { status: 'Odanız incelendi. Şimdi hemen gönderebileceğimiz halılar seçiliyor.' });
        return loadRecommendations(scope, analysis, runId, imagePayload);
      })
      .catch(function (error) {
        if (state.runId !== runId) return;
        console.error('[DV-AI-V5] Room analysis failed:', error.message);
        renderFatal(scope, friendlyError(error));
      });
  }

  function handleFile(scope, input) {
    var nodes = getNodes(scope);
    if (!nodes) return;
    var file = input.files && input.files[0];
    if (!file) return;
    if (!/^image\/(jpeg|png|webp)$/i.test(file.type || '')) {
      renderFatal(scope, 'Lütfen JPG, PNG veya WebP biçiminde geçerli bir oda fotoğrafı seçin.');
      input.value = '';
      return;
    }
    if (file.size > 10 * 1024 * 1024) {
      renderFatal(scope, 'Fotoğraf boyutu 10 MB sınırını aşıyor. Lütfen daha küçük bir görsel seçin.');
      input.value = '';
      return;
    }
    setLoading(nodes, true, 'Fotoğraf hazırlanıyor…', 'Fotoğrafınız hazırlanıyor');
    resizeImage(file)
      .then(function (image) {
        nodes.previewImage.src = image.preview;
        setHidden(nodes.preview, false);
        input.value = '';
        startAnalysis(scope, image.payload);
      })
      .catch(function (error) {
        console.error('[DV-AI-V5] Image preparation failed:', error.message);
        input.value = '';
        renderFatal(scope, 'Fotoğraf okunamadı. Lütfen farklı bir görsel seçin.');
      });
  }

  function boot() {
    if (typeof document === 'undefined' || document.documentElement.dataset.dvAiV5Booted === 'true') return;
    document.documentElement.dataset.dvAiV5Booted = 'true';

    document.addEventListener('click', function (event) {
      var upload = event.target.closest ? event.target.closest('#ai-v4-upload-btn') : null;
      if (upload) {
        var uploadScope = findScope(upload);
        var uploadNodes = getNodes(uploadScope);
        if (!uploadNodes) return;
        event.preventDefault();
        uploadNodes.input.click();
        return;
      }

      var confirmSize = event.target.closest ? event.target.closest('[data-dv-ai-confirm-size]') : null;
      if (confirmSize) {
        var confirmScope = findScope(confirmSize);
        if (!confirmScope) return;
        var confirmState = getState(confirmScope);
        if (!confirmState.analysis) return;
        event.preventDefault();
        var widthInput = confirmScope.querySelector('[data-dv-ai-size-width]');
        var lengthInput = confirmScope.querySelector('[data-dv-ai-size-length]');
        var confirmedAnalysis = confirmEstimatedSize(
          confirmState.analysis,
          widthInput ? widthInput.value : null,
          lengthInput ? lengthInput.value : null
        );
        if (!confirmedAnalysis) {
          renderView(confirmScope, confirmState.analysis, {
            empty: 'En ve boy için 40–600 cm arasında geçerli değerler girin.',
            confirmSize: true
          });
          return;
        }
        confirmState.analysis = confirmedAnalysis;
        confirmState.runId += 1;
        loadRecommendations(confirmScope, confirmedAnalysis, confirmState.runId, confirmState.imagePayload);
        return;
      }

      var retry = event.target.closest ? event.target.closest('[data-dv-ai-retry]') : null;
      if (retry) {
        var retryScope = findScope(retry);
        var retryState = getState(retryScope);
        if (!retryScope || !retryState.analysis) return;
        event.preventDefault();
        retryState.runId += 1;
        loadRecommendations(retryScope, retryState.analysis, retryState.runId, retryState.imagePayload);
      }
    });

    document.addEventListener('change', function (event) {
      if (!event.target || event.target.id !== 'ai-v4-file-input') return;
      var scope = findScope(event.target);
      if (scope) handleFile(scope, event.target);
    });

    console.log('[DV-AI-V5] Ready', VERSION);
  }

  return {
    VERSION: VERSION,
    CATALOG_VERSION: CATALOG_VERSION,
    STOCK_RULE: STOCK_RULE,
    cleanText: cleanText,
    searchKey: searchKey,
    asArray: asArray,
    parseDimensions: parseDimensions,
    normalizeEstimatedSize: normalizeEstimatedSize,
    confirmEstimatedSize: confirmEstimatedSize,
    normalizeAnalysis: normalizeAnalysis,
    extractFirstJsonObject: extractFirstJsonObject,
    extractVisionContent: extractVisionContent,
    parseVisionAnalysis: parseVisionAnalysis,
    safeImageUrl: safeImageUrl,
    safeProductPath: safeProductPath,
    normalizeVariant: normalizeVariant,
    normalizeProduct: normalizeProduct,
    selectBestVariant: selectBestVariant,
    productWithVariant: productWithVariant,
    validateCatalogPage: validateCatalogPage,
    fetchCatalog: fetchCatalog,
    verifyProduct: verifyProduct,
    verifyMatches: verifyMatches,
    revalidatePositiveStock: revalidatePositiveStock,
    scoreProducts: scoreProducts,
    normalizeVisualComparison: normalizeVisualComparison,
    buildVerifiedVisualReason: buildVerifiedVisualReason,
    mergeVisualRanking: mergeVisualRanking,
    visualComparisonPrompt: visualComparisonPrompt,
    formatMoney: formatMoney,
    renderView: renderView,
    boot: boot
  };
});
